<hr class="mt-6 mb-12 border-gray-400" />
